module.exports = __webpack_public_path__ + "img/logo_small.43845675.png";